
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/creating-themed-components",
      function () {
        return require("private-next-pages/joy-ui/customization/creating-themed-components.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/creating-themed-components"])
      });
    }
  